<script setup>

import {ErrorMessage, Field, Form} from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import GoogleAddress from '../Google/GoogleAddress.vue'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()
const schema = {
  email: 'required|email',
  phone: 'required|phoneNumber',
}

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)
const showCustomAddressLink = ref(false)

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('propertyMarketForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/submit-free-consult-form', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      setTimeout(function () {
        confirmation.show = false;
      }, 4000);
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}

const addressValueChange = (newVal, oldVal) => {
  showCustomAddressLink.value = newVal === 'no-address-found';
}
</script>

<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="propertyMarketForm"
    class="mt-2 mb-2"
  >
    <slot name="token"></slot>
    <div class="form-group form-group--input">
      <label for="name" class="sr-only">Enter your home address</label>
      <google-address
        :placeholder="'Enter your home address *'"
        :address-id="'address'"
        :classname="'form-control form-control--bg-white fs-14 ph-14'"
        v-on:addressvaluechange="addressValueChange"
      ></google-address>
<!--      <span class="is-danger" v-if="errors.has('address')" v-html="errors.first('address')"></span>-->
    </div>
    <div class="form-group form-group--input">
      <label for="email" class="sr-only">Your email</label>
      <Field
        id="email"
        name="email"
        class="form-control form-control--bg-white fs-14 ph-14"
        :class="{'is-danger': errors['email'] }"
        placeholder="Email *"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input mb-5">
      <label for="phone" class="sr-only">Your phone number</label>
      <Field
        id="phone"
        name="phone"
        class="form-control form-control--bg-white fs-14 ph-14"
        placeholder="You Phone number *"
        :class="{'is-danger': errors['phone'] }"
      />
      <ErrorMessage name="phone" class="is-danger" />
    </div>
    <transition name="fade">
      <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    </transition>

    <input type="hidden" name="captcha_action" value="property_market_form">
    <input type="submit" value="Receive report" class="btn btn--green btn--auto-width mb-0 fs-14 submit">
    <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
